import SkeletonLoaderRow, {
  SkeletonWrapper,
} from 'components/loading/SkeletonLoaderRow';
import React from 'react';
import styled from 'styled-components/native';
import { Divider } from 'styles/CommonLayoutStyles';
import { StyledWrapper } from 'styles/ContainerStyles';

const ItemRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
`;

const ItemColumn = styled.View<{ shrink?: boolean; ml?: number }>`
  flex-direction: column;
  flex-shrink: 2;
  gap: 8px;
`;

const Row = styled.View`
  flex-direction: row;
  gap: 5px;
`;

const SearchItemSkeleton: React.FC<{
  lastElement?: boolean;
}> = ({ lastElement }) => {
  return (
    <StyledWrapper mb={0}>
      <ItemRow>
        <ItemColumn>
          <Row>
            <SkeletonWrapper width={40}>
              <SkeletonLoaderRow height={20} />
            </SkeletonWrapper>
            <SkeletonWrapper width={220}>
              <SkeletonLoaderRow height={20} />
            </SkeletonWrapper>
          </Row>
          <Row>
            <SkeletonWrapper width={40}>
              <SkeletonLoaderRow height={15} />
            </SkeletonWrapper>
            <SkeletonWrapper width={180}>
              <SkeletonLoaderRow height={15} />
            </SkeletonWrapper>
          </Row>
        </ItemColumn>
        <ItemColumn>
          <SkeletonWrapper width={25}>
            <SkeletonLoaderRow height={25} />
          </SkeletonWrapper>
        </ItemColumn>
      </ItemRow>
      {!lastElement && <Divider />}
    </StyledWrapper>
  );
};

export default SearchItemSkeleton;
